import React, {useEffect} from "react";
import "./App.css";
import {BrowserRouter as Router, Navigate, Route, Routes} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "./reducers/reducer";
import {clearAuthState, updateAuthenticated} from "./reducers/authReducer";
import ProtectedRouteComponent from "./router/ProtectedRouteComponent";
import {clearProfile, updateProfile,} from "./reducers/profileReducer";
import {getUser} from "./api/userApi";
import {TokenStorage} from "./services/token.service";
import {setResponse} from "./services/http.service";
import {signout} from "./api/authApi";
import LoginScreen from "./components/screens/login/LoginScreen";
import PlanMapScreen from "./components/screens/plan/PlanMapScreen";
import ShippingMapScreen from "./components/screens/shipping/ShippingMapScreen";
import AuthRouteComponent from "./router/AuthRouteComponent";
import MenuTemplate from "./components/templates/MenuTemplate";
import {MainTemplate} from "./components/templates/MainTemplate";
import {showApiError} from "./common/message";
import {message} from "antd";

declare global {
  interface Window {
    $: any;
    Cypress: any;
    initialState: any;
    install: any;
    installed: boolean;
  }
}

if (process.env.REACT_APP_STAGE === "PROD") {
  console.log = function no_console() {
  };
}

function App() {
  const [messageApi, messageHolder] = message.useMessage();
  const dispatch = useDispatch();
  let verifyCalled = false;
  const {authenticated} = useSelector((state: RootState) => state.auth);
  
  const appHeight = () => {
    const doc = document.documentElement;
    setTimeout(() => {
      if (doc) {
        let vh = window.innerHeight * 0.01;
        doc.style.setProperty("--vh", `${vh}px`);
      }
    }, 100);
  };
  
  const onContext = (e: any) => {
    // e.preventDefault();
  };
  
  const onBeforeAppInstalled = (e: any) => {
    e.preventDefault();
    window.install = e;
  };
  
  const onAppInstalled = () => {
    window.installed = true;
  };
  
  const onContentLoaded = () => {
    if (// @ts-ignore
      navigator?.standalone || window.matchMedia("(display-mode: standalone)").matches || window.matchMedia("(display-mode: fullscreen)").matches || window.matchMedia("(display-mode: minimal-ui)").matches) {
      window.installed = true;
    }
  };
  
  useEffect(() => {
    setResponse(dispatch);
    document.addEventListener("contextmenu", onContext);
    window.addEventListener("resize", appHeight);
    appHeight();
    window.addEventListener("beforeinstallprompt", onBeforeAppInstalled);
    
    if (!navigator.serviceWorker) {
      window.installed = true;
    }
    
    window.addEventListener("appinstalled", onAppInstalled);
    
    //but also add a listener. After app installation on desktop, the app will open in their own window right away.
    window.addEventListener("DOMContentLoaded", onContentLoaded);
    
    return () => {
      window.removeEventListener("resize", appHeight);
      window.removeEventListener("contextmenu", onContext);
      window.removeEventListener("beforeinstallprompt", onBeforeAppInstalled);
      window.removeEventListener("DOMContentLoaded", onContentLoaded);
      window.removeEventListener("appinstalled", onAppInstalled);
    };
  }, []);
  
  useEffect(() => {
    if (TokenStorage.isAuthenticated() && !verifyCalled) {
      verifyCalled = true;
      TokenStorage.verifyToken(onTokenValid, onRefreshError);
    }
  }, []);
  
  useEffect(() => {
    console.log("clearProfile", authenticated);
    if (authenticated === false) {
      const refresh = TokenStorage.getRefreshToken();
      if (refresh) {
        signout(refresh, () => {
          TokenStorage.clear();
          dispatch(clearProfile());
        }, (e) => {
          TokenStorage.clear();
          dispatch(clearProfile());
        });
      }
    }
  }, [authenticated, dispatch]);
  
  const onTokenValid = () => {
    dispatch(updateAuthenticated(true));
    getUser((pro) => {
      dispatch(updateProfile(pro));
    }, (e) => showApiError(e, messageApi));
  };
  
  const onRefreshError = (e: any) => {
    dispatch(clearProfile());
    dispatch(clearAuthState());
  };
  
  return (<Router>
    <Routes>
      <Route element={<MainTemplate />}>
        <Route element={<MenuTemplate />}>
          <Route path={"/box/plan"} element={<ProtectedRouteComponent isLoggedIn={authenticated} showBreadTitle={false}>
            <PlanMapScreen />
          </ProtectedRouteComponent>} />
          <Route path={"/status/shipping"}
                 element={<ProtectedRouteComponent isLoggedIn={authenticated} showBreadTitle={false}>
                   <ShippingMapScreen />
                 </ProtectedRouteComponent>} />
          <Route
            path="*"
            element={<Navigate to="/box/plan" replace />}
          />
        </Route>
        <Route path="/auth" element={<LoginScreen />}>
          <Route index path={"/auth/login"} element={<AuthRouteComponent>
            <LoginScreen />
          </AuthRouteComponent>} /> <Route
          path="*"
          element={<Navigate to="/box/plan" replace />}
        />
        </Route>
        <Route
          path="*"
          element={<Navigate to="/box/plan" replace />}
        />
      </Route>
    </Routes>
    {messageHolder}
  </Router>);
}

export default App;
